import { render, staticRenderFns } from "./fangaiRights.vue?vue&type=template&id=5ed1f8f3&scoped=true&"
import script from "./fangaiRights.vue?vue&type=script&lang=js&"
export * from "./fangaiRights.vue?vue&type=script&lang=js&"
import style0 from "./fangaiRights.vue?vue&type=style&index=0&id=5ed1f8f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1f8f3",
  null
  
)

export default component.exports